import { Component, ElementRef, AfterViewInit, ViewChild, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { CmsComponent } from "@signature-it/ngx-generic/components/cms";
import { ShareDataService} from "@signature-it/ngx-generic/services";
import { MainHeaderComponentGeneric } from "@signature-it/ngx-generic/components/header";

declare let $: any;

@Component({
    selector: 'main-header',
    templateUrl: './main-header.html',
    styleUrls: ['./main-header.scss'],
    standalone: false
})
export class MainHeaderComponent extends MainHeaderComponentGeneric implements AfterViewInit, OnInit, OnDestroy {

    listener;

    @ViewChild('cmsComp', {static: false}) cmsComp: CmsComponent;
    @ViewChild('containerRef', {static: false}) containerRef: ElementRef;


    constructor(protected elRef: ElementRef,
                public shareSvc: ShareDataService,
                private renderer2: Renderer2) {
        super(elRef, shareSvc);

        // for old effect? (probably not in use anymore)
        this.listener = this.renderer2.listen('window', 'scroll', (e) => {
            if(document.body.scrollTop > 0 || document.documentElement.scrollTop > 0){
                this.renderer2.addClass(document.body, 'wsActive');
            } else {
                this.renderer2.removeClass(document.body, 'wsActive');
            }
        });

        // values calculations for css vars
        let observer = new MutationObserver((mutations) => {
            // header height after all its content is rendered
            document.documentElement.style.setProperty('--headerHeight', this.elRef.nativeElement.offsetHeight+'px');

            // net window size (without the scrollbar width) AFTER all the document content is rendered
            document.documentElement.style.setProperty('--netWindowWidth', document.body.clientWidth+'px');
        });
        observer.observe(document, {childList: true, subtree: true})
    }

    ngAfterViewInit(): void {
        super.ngAfterViewInit();
    }

    ngOnInit(): void {
        super.ngOnInit();

    }

    ngOnDestroy(): void {
        this.listener();
    }

}
